(function () {

    'use strict';

    angular.module('Services').service('PopLockerProvidersTable', PopLockerProvidersTable);

    PopLockerProvidersTable.$inject = [
        'PopLockerService',
        'TableLiteFactory',
        '$location',
        'ConfirmationModalFactory',
        'toastr'
    ];

    function PopLockerProvidersTable(
        PopLockerService,
        TableLiteFactory,
        $location,
        ConfirmationModalFactory,
        toastr
    ) {
        return function () {
            const deleteConfirmationModal = new ConfirmationModalFactory({}, {
                message: 'messages.warning.deletePopLockerProvider.MESSAGE',
                code: 'messages.warning.deletePopLockerProvider.CODE'
            });

            const tableData = {
                tableName: 'popLockerProvidersTable',
                optionAddOns: {
                    buttons: [{
                        class: 'btn-primary',
                        label: 'Add Provider',
                        tooltip: 'Click to add new pop locker provider.',
                        onClick: function () {
                            $location.path('/carriers/pop-lockers/add');
                        }
                    }]
                },
                config: {
                    noPagination: false,
                    noHeaders: false,
                    noItemsView: false,
                    noTableFooter: false,
                    colMinWidth: '100px'
                },
                headers: [
                    {
                        label: 'Order',
                        viewName: 'order',
                        width: '100px',
                        headerFn: function () {
                            sort(this.filterName);
                        }
                    },
                    {
                        label: 'Provider Name',
                        viewName: 'providerName',
                        filter: {
                            type: 'text',
                            placeholder: 'Search',
                            onSubmit: function (header) {
                                sendRequest(evaluateFilter(header));
                            }
                        },
                        headerFn: function () {
                            sort(this.filterName);
                        }
                    },
                    {
                        label: 'Status',
                        viewName: 'status',
                        width: '100px',
                        filter: {
                            type: 'select2',
                            placeholder: 'Select Status',
                            items: ['Enabled', 'Disabled'],
                            onSelect: function (header) {
                                sendRequest(evaluateFilter(header));
                            }
                        },
                        headerFn: function () {
                            sort(this.filterName);
                        }
                    },
                    {
                        label: 'Actions',
                        viewName: 'actions',
                        width: '200px'
                    }
                ],
                data: []
            };

            const tableActions = new TableLiteFactory(tableData, {
                serviceCallback: PopLockerService.getAll,
                callbackFormat: ['success', 'error', 'filter'],
                postRequestCallback: data => {
                    buildTableData(data);
                },
                postRequestErrorCallback: err => {
                    buildTableData(null);
                },
                defaultFilters: {
                    size: 20,
                    page: 0,
                    sort: 'id,desc'
                }
            });

            const sort = tableActions.sort;
            const evaluateFilter = tableActions.evaluateFilter;
            const sendRequest = tableActions.sendRequest;

            function buildTableData(data) {
                tableActions.initializeTableData(data);
                if (!data) { return null; }

                angular.forEach(data.content, function (row) {
                    row.status = {
                        type: 'status',
                        status: row.active,
                        label: row.active ? 'Active' : 'Inactive'
                    }
                    row.actions = buildButtons(row);
                    row.href = `/carriers/pop-lockers/${row.id}`; // todo: add implementation code here
                    tableData.data.push(row);
                });
            }

            function buildButtons(data) {
                return {
                    type: 'button',
                    buttons: [addStatusButtons(data), {
                        text: 'Delete',
                        class: 'btn btn-danger',
                        action: function (row) {
                            deleteProvider(row);
                        }
                    }]
                }
            }

            function addStatusButtons(data) {
                if (data.active) {
                    return {
                        text: 'Disable',
                        class: 'btn btn-default',
                        action: function (row) {
                            updateProviderStatus(row);
                        }
                    }
                }
                return {
                    text: 'Enable',
                    class: 'btn btn-green',
                    action: function (row) {
                        updateProviderStatus(row);
                    }
                }
            }

            function updateProviderStatus(data) {
                data.active = !data.active;
                const payload = PopLockerService.payloadMapper(data);
                PopLockerService.updateById(data.id, success => {
                    toastr.success('Pop locker provider successfully updated.', 'Success');
                    sendRequest();
                }, error => {
                    toastr.error(error.message, 'Error');
                }, payload);
            }

            function deleteProvider(data) {
                deleteConfirmationModal.getInstance().result.then(cond => {
                    if (cond) {
                        PopLockerService.delete(data.id, success => {
                            sendRequest();
                            toastr.success('Pop locker provider successfully deleted.', 'Success');
                        }, error => {
                            toastr.error(error.message, "Error");
                        });
                    }
                });
            }

            this.tableData = tableData;
        }
    }
})();



// WEBPACK FOOTER //
// ./js/services/tables/pop-lockers/PopLockerProvidersTable.js